import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';

import { cn } from '@heidi/utils';

import { useIsExperimentalDesignSystemForms } from '../hooks/use-is-experimental-design-system-forms';
import {
  labelDescriptionClassesExperimental,
  labelVariantsExperimental,
  labelWithDescriptionClasses,
} from './label.experimental.styles';
import { labelVariants } from './label.styles';
import type { LabelProps } from './label.types';

export const getLabelDescriptionId = (id: string): string => `${id}-description`;

const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, description, descriptionClassName, children, ...props }, ref) => {
    const isExperimentalForms = useIsExperimentalDesignSystemForms();

    const label = (
      <LabelPrimitive.Root
        ref={ref}
        data-experimental={isExperimentalForms || undefined}
        className={cn(
          isExperimentalForms ? labelVariantsExperimental() : labelVariants(),
          className
        )}
        {...props}
      >
        {children}
      </LabelPrimitive.Root>
    );

    // Stable has no supporting-text tier, so the description is experimental-only.
    if (!description || !isExperimentalForms) return label;

    return (
      <div className={labelWithDescriptionClasses}>
        {label}
        {/* Sibling, never a child — nesting would fold this into the accessible name. */}
        <span
          id={props.id ? getLabelDescriptionId(props.id) : undefined}
          className={cn(labelDescriptionClassesExperimental, descriptionClassName)}
        >
          {description}
        </span>
      </div>
    );
  }
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
